"use client";

import { ArrowRight, ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: metaRef,
    isVisible: metaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const dataPoints = [{
    label: "AI VISIBILITY",
    value: "100%"
  }, {
    label: "SEARCH RANK",
    value: "TOP 3"
  }, {
    label: "DATA ACCURACY",
    value: "VERIFIED"
  }];
  return <section data-section-id="3626" id="beforeaftercomparisonhero" className="bg-background text-foreground relative min-h-screen w-full overflow-hidden isolate">
      {}
      <div className="absolute inset-0" style={{
      background: "radial-gradient(ellipse at center, hsla(0, 0%, 0%, 0.5) 0%, hsla(0, 0%, 0%, 0.9) 70%, hsla(0, 0%, 0%, 0.98) 100%)"
    }} />

      {}
      <div className="absolute inset-0 mix-blend-overlay opacity-40" style={{
      background: "radial-gradient(circle at 30% 40%, hsla(352, 54%, 25%, 0.2) 0%, transparent 60%)"
    }} />

      {}
      <div className="absolute top-0 left-0 right-0 h-px bg-border/60" />

      {}
      <div className="relative z-10 mx-auto flex min-h-screen w-full max-w-[1600px] flex-col px-6 pt-24 pb-32 sm:px-10 lg:px-16">
        <div className="grid flex-1 grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-8">
          {}
          <div ref={headlineRef} className={`lg:col-span-9 flex flex-col justify-center transition-all duration-1000 ease-out ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="mb-8 flex items-center gap-4">
              <span className="h-px w-12 bg-accent-deep-red" />
              <span className="font-default text-xs uppercase tracking-[0.3em] text-muted-foreground">
                ClearLine — AI Search Authority
              </span>
            </div>

            {}
            <h1 className="font-default font-bold uppercase leading-[0.85] tracking-tight text-foreground">
              <span className="block !text-4xl sm:!text-5xl">SEO Gets You Found. GEO Gets You Recommended.</span>
              <span className="block text-[clamp(3.5rem,12vw,10rem)]"></span>
            </h1>

            {}
            <div className="my-10 h-[2px] w-20 bg-accent-deep-red" />

            {}
            <p className="font-default text-lg sm:text-xl text-muted-foreground max-w-[520px] leading-relaxed">Traditional SEO helps customers find your website through Google. Generative Engine Optimization (GEO) helps AI platforms like ChatGPT, Gemini, Claude, Grok, and Perplexity confidently recommend your business when customers ask who they should hire. In today's search landscape, businesses need both to stay visible.</p>

            {}
            <div className="mt-12 flex flex-col sm:flex-row gap-4 sm:items-center">
              <Button asChild size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive rounded-md has-[>svg]:px-4 group h-14 px-8 font-default font-bold uppercase tracking-wider text-sm shadow-lg hover:bg-accent-deep-red/90 transition-all duration-300 bg-destructive text-primary-foreground">
                <Link to="/PricingPlansPage">Get started without call </Link>
              </Button>

              <Button asChild variant="link" className="font-default text-xs uppercase tracking-[0.25em] text-foreground hover:text-accent-deep-red h-14 px-2">
                <Link to="/VisibilityCheckupPage">Free AI visibility checkup →</Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={metaRef} className={`hidden lg:col-span-3 lg:flex items-stretch justify-end transition-all duration-1000 delay-300 ease-out ${metaVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="relative flex items-center">
              <div className="absolute right-0 top-0 bottom-0 w-px bg-border/60" />
              <div className="font-default text-xs uppercase tracking-[0.2em] whitespace-nowrap pr-6 text-destructive" style={{
              writingMode: "vertical-rl",
              transform: "rotate(180deg)"
            }}>AI SEARCH OPTIMIZATION / LOCAL SERVICE BUSINESSES / CLEARLINE </div>
            </div>
          </div>
        </div>

        {}
        <div className="relative z-10 mt-16 flex flex-col gap-8">
          {}
          <div className="flex items-center gap-3">
            <span className="font-default text-xs uppercase tracking-[0.3em] text-muted-foreground">
              Scroll
            </span>
            <ChevronDown className="size-4 text-accent-deep-red animate-bounce" />
          </div>

          {}
          <div className="h-px w-full bg-border/60" />

          {}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-4">
            {dataPoints.map((point, i) => <div data-index={i} key={point.label} className="flex items-baseline gap-4">
                <span className="font-default text-xs uppercase tracking-[0.25em] text-muted-foreground">
                  {point.label}
                </span>
                <span className="font-default font-bold text-lg text-accent-deep-red">
                  {point.value}
                </span>
              </div>)}
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-border/60" />
    </section>;
}